import type { ProjectionLog } from "../../../projections/projectionEngine.js";

export function readVoiceActorId(log: Pick<ProjectionLog, "target" | "executor">): string | null {
    return log.target || log.executor || null;
}

export function readVoiceChannelId(log: Pick<ProjectionLog, "channel" | "to" | "from">): string | null {
    return log.channel || log.to || log.from || null;
}

export function sameVoiceLog(left: ProjectionLog | null | undefined, right: ProjectionLog | null | undefined): boolean {
    if (!left || !right)
        return false;

    if (left.id && right.id)
        return left.id === right.id;

    return left.type === right.type
        && left.createdAt === right.createdAt
        && left.executor === right.executor
        && left.target === right.target
        && left.channel === right.channel
        && left.from === right.from
        && left.to === right.to;
}

export function formatVoiceTime(timestamp: number): string {
    return new Date(timestamp).toLocaleTimeString("fr-FR", {
        hour    : "2-digit",
        minute  : "2-digit",
    });
}
